import accessibility_en from './en/accessibility.json';
import auth_en from './en/auth.json';
import calendar_en from './en/calendar.json';
import classroom_en from './en/classroom.json';
import common_en from './en/common.json';
import courses_en from './en/courses.json';
import editorial_en from './en/editorial.json';
import grades_en from './en/grades.json';
import header_en from './en/header.json';
import lemonade_en from './en/lemonade.json';
import lesson_en from './en/lesson.json';
import library_en from './en/library.json';
import message_en from './en/message.json';
import profile_en from './en/profile.json';
import project_en from './en/project.json';
import signup_en from './en/signup.json';
import sync_en from './en/sync.json';
import tasks_en from './en/tasks.json';
import teams_en from './en/teams.json';
import test_en from './en/test.json';
import titles_en from './en/titles.json';
import accessibility_es from './es/accessibility.json';
import auth_es from './es/auth.json';
import calendar_es from './es/calendar.json';
import classroom_es from './es/classroom.json';
import common_es from './es/common.json';
import courses_es from './es/courses.json';
import editorial_es from './es/editorial.json';
import grades_es from './es/grades.json';
import header_es from './es/header.json';
import lemonade_es from './es/lemonade.json';
import lesson_es from './es/lesson.json';
import library_es from './es/library.json';
import message_es from './es/message.json';
import profile_es from './es/profile.json';
import project_es from './es/project.json';
import signup_es from './es/signup.json';
import sync_es from './es/sync.json';
import tasks_es from './es/tasks.json';
import teams_es from './es/teams.json';
import test_es from './es/test.json';
import titles_es from './es/titles.json';
import accessibility_pt from './pt/accessibility.json';
import auth_pt from './pt/auth.json';
import calendar_pt from './pt/calendar.json';
import classroom_pt from './pt/classroom.json';
import common_pt from './pt/common.json';
import courses_pt from './pt/courses.json';
import editorial_pt from './pt/editorial.json';
import grades_pt from './pt/grades.json';
import header_pt from './pt/header.json';
import lemonade_pt from './pt/lemonade.json';
import lesson_pt from './pt/lesson.json';
import library_pt from './pt/library.json';
import message_pt from './pt/message.json';
import profile_pt from './pt/profile.json';
import project_pt from './pt/project.json';
import signup_pt from './pt/signup.json';
import sync_pt from './pt/sync.json';
import tasks_pt from './pt/tasks.json';
import teams_pt from './pt/teams.json';
import test_pt from './pt/test.json';
import titles_pt from './pt/titles.json';

export const DEFAULT_RESOURCES_ES = [
  auth_es,
  courses_es,
  common_es,
  header_es,
  calendar_es,
  classroom_es,
  lesson_es,
  profile_es,
  signup_es,
  tasks_es,
  test_es,
  lemonade_es,
  grades_es,
  project_es,
  editorial_es,
  teams_es,
  titles_es,
  message_es,
  library_es,
  accessibility_es,
  sync_es,
];

export const DEFAULT_RESOURCES_EN = [
  auth_en,
  courses_en,
  common_en,
  header_en,
  calendar_en,
  classroom_en,
  lesson_en,
  profile_en,
  signup_en,
  tasks_en,
  test_en,
  lemonade_en,
  grades_en,
  project_en,
  editorial_en,
  teams_en,
  titles_en,
  message_en,
  library_en,
  accessibility_en,
  sync_en,
];

export const DEFAULT_RESOURCES_PT = [
  auth_pt,
  courses_pt,
  common_pt,
  header_pt,
  calendar_pt,
  classroom_pt,
  lesson_pt,
  profile_pt,
  signup_pt,
  tasks_pt,
  test_pt,
  lemonade_pt,
  grades_pt,
  project_pt,
  editorial_pt,
  teams_pt,
  titles_pt,
  message_pt,
  library_pt,
  accessibility_pt,
  sync_pt,
];
